export default defineNuxtPlugin(() => {
  // Suppress Vue Router warnings for Chrome DevTools well-known paths
  if (process.client) {
    const originalWarn = console.warn
    console.warn = (...args: any[]) => {
      const message = args[0]?.toString() || ''
      // Only suppress Vue Router warnings about .well-known paths
      if (
        (message.includes('Vue Router warn') || message.includes('[Vue Router warn]')) &&
        (message.includes('.well-known') || message.includes('appspecific'))
      ) {
        return
      }
      originalWarn.apply(console, args)
    }
  }
})
